import { CodeBase } from "./_codeBase";

/**
 * 取込区分
 */
export class ImportType extends CodeBase<ImportType>
{
    /** 取込区分 "01", "追加" */
    public static readonly ADDED: ImportType = new ImportType("01", "追加");
    /** 取込区分 "02", "取込" */
    public static readonly EDITED: ImportType = new ImportType("02", "変更");
    /** 取込区分 "03", "削除" */
    public static readonly DELETED: ImportType = new ImportType("03", "削除");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ImportType[] {
        return [
            ImportType.ADDED,
            ImportType.EDITED,
            ImportType.DELETED,
        ];
    }
}
